/* @flow */

/**
 * The type of the action which signals to open the conference in the desktop
 * app.
 *
 * {
 *     type: OPEN_DESKTOP
 * }
 */
export const OPEN_DESKTOP_APP = 'OPEN_DESKTOP_APP';

/**
 * The type of the action which signals to open the conference in the web app.
 *
 * {
 *     type: OPEN_WEB_APP
 * }
 */
export const OPEN_WEB_APP = 'OPEN_WEB_APP';
